import { LabAccount as _LabAccount } from '@team-milva/lab-models/labAccount'

export class LabAccount extends _LabAccount {
  constructor(params: Partial<_LabAccount> = {}) {
    super(params)
  }
}
